var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevop1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3797_45627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3797_45627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.5801,
    width: 64,
    height: 64,
    rx: 13.7143,
    fill: "url(#paint0_linear_3797_45627)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3797_45627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.6953,
    width: 64,
    height: 64,
    rx: 13.7143,
    fill: "url(#paint1_linear_3797_45627)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3797_45627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1093 45.1309H40.8281C39.9762 45.1309 39.2856 45.8318 39.2856 46.6965V62.131C39.2856 62.9956 39.9762 63.6966 40.8281 63.6966H45.1093C45.9611 63.6966 46.6517 62.9956 46.6517 62.131V46.6965C46.6517 45.8318 45.9611 45.1309 45.1093 45.1309Z",
    fill: "url(#paint2_linear_3797_45627)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1093 45.1309H40.8281C39.9762 45.1309 39.2856 45.8318 39.2856 46.6965V62.131C39.2856 62.9956 39.9762 63.6966 40.8281 63.6966H45.1093C45.9611 63.6966 46.6517 62.9956 46.6517 62.131V46.6965C46.6517 45.8318 45.9611 45.1309 45.1093 45.1309Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.80266,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3797_45627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9458 44.7623V64.0172C49.9458 64.1646 50.0426 64.2956 50.1845 64.3316L59.5339 66.9186C60.1501 67.0888 60.7566 66.6173 60.7566 65.9722V42.5355C60.7566 41.3763 59.5984 40.5839 58.5402 41.0161L50.1523 44.4578C50.0297 44.5069 49.949 44.6281 49.949 44.7623H49.9458Z",
    fill: "url(#paint3_linear_3797_45627)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9458 44.7623V64.0172C49.9458 64.1646 50.0426 64.2956 50.1845 64.3316L59.5339 66.9186C60.1501 67.0888 60.7566 66.6173 60.7566 65.9722V42.5355C60.7566 41.3763 59.5984 40.5839 58.5402 41.0161L50.1523 44.4578C50.0297 44.5069 49.949 44.6281 49.949 44.7623H49.9458Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.91536,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3797_45627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3735 41.2747V66.7869C64.3735 66.8164 64.4025 66.8311 64.4279 66.82L66.8515 65.4926V43.4957C66.8515 43.4111 66.8225 43.3302 66.7718 43.2677L65.0147 41.0357C64.7974 40.7599 64.3735 40.9217 64.3735 41.2783V41.2747Z",
    fill: "url(#paint4_linear_3797_45627)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3735 41.2747V66.7869C64.3735 66.8164 64.4025 66.8311 64.4279 66.82L66.8515 65.4926V43.4957C66.8515 43.4111 66.8225 43.3302 66.7718 43.2677L65.0147 41.0357C64.7974 40.7599 64.3735 40.9217 64.3735 41.2783V41.2747Z",
    stroke: "#F5F5F5",
    strokeWidth: 2.15081,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3797_45627",
    x: 0.0488763,
    y: 0.744189,
    width: 94.8281,
    height: 100.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.09511,
    dy: 3.29232
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.98603
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.680139 0 0 0 0 0.685144 0 0 0 0 0.691667 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.98603,
    dy: -5.98603
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.48254
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.968627 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3797_45627",
    result: "effect2_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3797_45627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3797_45627",
    x: 1.95879,
    y: 2.65411,
    width: 92.0178,
    height: 96.9141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.90412,
    dy: 2.99219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.44034
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.680139 0 0 0 0 0.685144 0 0 0 0 0.691667 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.44034,
    dy: -5.44034
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.80043
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.968627 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3797_45627",
    result: "effect2_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3797_45627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3797_45627",
    x: 36.0905,
    y: 43.1879,
    width: 13.7565,
    height: 24.9547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25114
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.235294 0 0 0 0 0.32549 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3797_45627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3797_45627",
    x: 46.5511,
    y: 38.8297,
    width: 17.6004,
    height: 32.849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.235294 0 0 0 0 0.32549 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3797_45627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3797_45627",
    x: 60.5616,
    y: 38.5783,
    width: 10.1019,
    height: 33.5497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.49278
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36838
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.235294 0 0 0 0 0.32549 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3797_45627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3797_45627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3797_45627",
    x1: 21,
    y1: -11.0822,
    x2: 101.005,
    y2: 83.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CACF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406669,
    stopColor: "#5D9AE7",
    stopOpacity: 0.857607
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774828,
    stopColor: "#96B1E6",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908106,
    stopColor: "#80A1E3",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7499E1",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3797_45627",
    x1: 21,
    y1: 2.72388,
    x2: 98.7143,
    y2: 95.5239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B99FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49086,
    stopColor: "#6DCFDA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725524,
    stopColor: "#9EDAD2",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884525,
    stopColor: "#BCE1CD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECC6",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3797_45627",
    x1: 39.2856,
    y1: 39.6275,
    x2: 57.0066,
    y2: 48.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B99FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49086,
    stopColor: "#6DCFDA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725524,
    stopColor: "#9EDAD2",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884525,
    stopColor: "#BCE1CD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECC6",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3797_45627",
    x1: 49.9458,
    y1: 33.1724,
    x2: 75.5157,
    y2: 45.8403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B99FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49086,
    stopColor: "#6DCFDA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725524,
    stopColor: "#9EDAD2",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884525,
    stopColor: "#BCE1CD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECC6",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3797_45627",
    x1: 64.3735,
    y1: 33.2109,
    x2: 71.579,
    y2: 34.0332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B99FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49086,
    stopColor: "#6DCFDA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725524,
    stopColor: "#9EDAD2",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884525,
    stopColor: "#BCE1CD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECC6",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3797_45627"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21.6953,
    width: 64,
    height: 64,
    rx: 9.14286,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevop1);
export default __webpack_public_path__ + "static/media/devop1.3cadb394685feb12e6114c19a8f9d719.svg";
export { ForwardRef as ReactComponent };